// Nếu text có định dạng email thì trả về true, ngược lại thì false
const isEmail = (email:string):boolean => {
  // Regular expression to check for a valid email address
  const regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  // Return true if the email address is valid, false otherwise
  return regex.test(email?.replace(/ /g, ''));
};

//Kiểm tra xem chuỗi đầu vào có phải là liên kết hình ảnh hay không
function isImageUrl(url:string):boolean {
  const imagePattern = /^https:\/\/.*\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i;
  return imagePattern.test(url);
};

export { isEmail ,isImageUrl};
